import React, { useState } from 'react';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import makeStyles from '@mui/styles/makeStyles';

import { Title, BaseLayout } from '../..';

const useStyles = makeStyles((theme) => ({
	paper: {
		padding: theme.spacing(3),
		display: 'flex',
		overflow: 'auto',
		flexDirection: 'column'
	},
	fixedHeight: {
		height: 120
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff'
	}
}));

export default function NotAuthorized() {
	const classes = useStyles();
	return (
		<BaseLayout>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<Title> You do not have permission to view this page.</Title>
					</Paper>
				</Grid>
			</Grid>
		</BaseLayout>
	);
}
